import { CartStateModelGeneric } from '@signature-it/ngx-catalogue/store/models';
import { GetTemporaryTransactionDTO } from '@signature-it/ngx-catalogue/models';
import { CartActions } from '@signature-it/ngx-catalogue/store/actions';
import {createReducer, on} from "@ngrx/store";

declare let _: any;

export const cartInitialState = new CartStateModelGeneric();

export const cartReducer = createReducer(
    cartInitialState,
    on(CartActions.addToCart, (state, { options}) => ({ ...state, ...{
            processingAddToCart: true,
            addToCartAfterRemove: options && options['afterRemoveAll'] ? true : false} })),
    on(CartActions.addToCartSuccess, (state, {payload, options}) => ({ ...state, ...{
            cartProductIds: _.uniq(state.cartProductIds.concat(payload['products'].map(p => p.product_id))),
            processingAddToCart: false,
            addToCartOpenModal: options && options['afterRemoveAll'] ? false : true,
            redirectLink: options && options['afterRemoveAll'] ? true : false,
            addToCartAfterRemove: false,
            addToCartError: null,
            itemsQuantity:  {
                total_quantity: payload['total']
            },
        } })),
    on(CartActions.addToCartFailure, (state, {error}) => ({ ...state, ...{
            processingAddToCart: false,
            addToCartError: error
        }})),
    on(CartActions.addToCartCloseFailure, (state) => ({ ...state, ...{
            addToCartError: null
        }})),
    on(CartActions.addToCartCloseModal, (state) => ({ ...state, ...{
            addToCartOpenModal: false
        }})),
    on(CartActions.redirectLinkDone, (state) => ({ ...state, ...{
            redirectLink: false
        }})),
    on(CartActions.getCart, (state) => ({ ...state, ...{
            processingGetCart: true,
            loadingUpdatedCart: true,
            loadingTotalPrice: true
        }})),
    on(CartActions.gotCartSuccess, (state, payload) => ({ ...state, ...{
            cart: GetTemporaryTransactionDTO.create(payload),
            cartProductIds: payload['Transaction'] ? payload['Transaction']['TransactionItems'].filter((item) =>  !item['ParentLineId']).map(item => item['ProductID']) : [],
            processingGetCart: false,
            loadingUpdatedCart: false,
            updateAllQuantities: false // we call get cart if updateAllQuantities equals true
        }})),
    on(CartActions.gotCartFailure, (state, {error}) => ({ ...state, ...{
            processingGetCart: false,
            loadingUpdatedCart: false
        }})),
    on(CartActions.getItemsQuantity, (state) => ({ ...state, ...{
            loadingTotalQuantity: false
        }})),
    on(CartActions.gotItemsQuantitySuccess, (state, payload) => ({ ...state, ...{
            itemsQuantity: payload,
            loadingTotalQuantity: false
        }})),
    on(CartActions.gotItemsQuantityFailure, (state, {error}) => ({ ...state, ...{
            loadingTotalQuantity: false
        }})),
    on(CartActions.removeItem, (state, {payload}) => ({ ...state, ...{
            loadingUpdatedCart: true,
            loadingTotalQuantity: true,
            loadingTotalPrice: true
        }})),
    on(CartActions.removeItemSuccess, (state, { cart, quantity, cartProductIds }) => ({ ...state, ...{
            itemsQuantity: {
                total_quantity: quantity
            },
            cart: cart,
            loadingUpdatedCart: false,
            loadingTotalQuantity: false,
            cartProductIds: cartProductIds
        }})),
    on(CartActions.removeItemFailure, (state, {error}) => ({ ...state, ...{
            loadingUpdatedCart: false
        }})),
    on(CartActions.removeAllItems, (state) => ({ ...state, ...{
            updatedCartSuccess: false,
            loadingUpdatedCart: true
        }})),
    on(CartActions.removeAllItemsSuccess, (state, {cart}) => ({ ...state, ...{
            itemsQuantity:  {
                total_quantity: 0
            },
            cart: cart,
            loadingUpdatedCart: false,
            cartProductIds: [],
            updatedCartSuccess: true,
            removeAllItemsError: null,
        }})),
    on(CartActions.removeAllItemsFailure, (state, {error}) => ({ ...state, ...{
            loadingUpdatedCart: false,
            removeAllItemsError: error,
        }})),
    on(CartActions.getTotalPrice, (state) => ({ ...state, ...{
            loadingTotalPrice: true,
            totalPriceError: null
        }})),
    on(CartActions.gotTotalPriceSuccess, (state, payload) => ({ ...state, ...{
            totalPrice: payload,
            totalPriceError: null,
            loadingTotalPrice: false
        }})),
    on(CartActions.gotTotalPriceFailure, (state, {error}) => ({ ...state, ...{
            loadingTotalPrice: false,
            totalPriceError: error
        }})),
    on(CartActions.checkout, (state) => ({ ...state, ...{
            processingCheckout: true
        }})),
    on(CartActions.checkoutSuccess, (state, {cart}) => ({ ...state, ...{
            processingCheckout: false,
            itemsQuantity: {
                total_quantity: 0
            },
            cart: cart
        }})),
    on(CartActions.checkoutFailure, (state, {error}) => ({ ...state, ...{
            processingCheckout: false,
            checkoutError: error
        }})),
    on(CartActions.updateAllQuantities, (state) => ({ ...state, ...{
            updateAllQuantities: true
        }})),
    on(CartActions.skipModalAfterAddToCart, (state, payload) => ({ ...state, ...{
            skipModalAfterAddToCart: payload
        }})),
    on(CartActions.getShippingMethods, (state) => ({ ...state, ...{
            loadingShippingMethods: true
        }})),
    on(CartActions.gotShippingMethodsSuccess, (state, {payload}) => ({ ...state, ...{
            shippingMethods: payload,
            loadingShippingMethods: false
        }})),
    on(CartActions.gotShippingMethodsFailure, (state) => ({ ...state, ...{
            loadingShippingMethods: false
        }})),
);
